"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowName = void 0;
exports.WorkflowName = {
    PALLET_BUILDING: "PALLET_BUILDING",
    LABEL_PURCHASE: "LABEL_PURCHASE",
    EACHES_PACKAGING: "EACHES_PACKAGING",
    NULL: "",
};
//# sourceMappingURL=workflow-name.js.map